<template>
  <div>
    <div class="infographic-list">
      <ul class="infographic-list-inner align-between">
        <li v-for="(data, idx) in statReportDataList" v-bind:key="idx">

          <div class="info-img" @click="fileViewer(data)" :title="data.statRptNm + ' 바로보기'">
              <img :src="getImage(data)" :alt="data.statRptNm" :title="data.statRptNm"
              @error="errorImageHandler">
          </div>

          <div class="info-cnt">
            <div class="info-cnt-top">
              <span class="category">{{data.tblSrcNm}}</span>
              <p class="info-title" style="word-break: break-all;">{{data.statRptNm}}</p>
            </div>
            <div class="bundle info-cnt-bottom">
              <span class="info-date type02">
                <span class="page"><i class="hidden">총 페이지수 :</i>{{data.pageCnt | addComma}} 페이지</span>
                <span class="viewer"><i class="hidden">조회수 :</i>{{data.visitCnt | addComma}}</span>
                <span class="date"><i class="hidden">등록일 :</i>{{data.regDate}}</span>
              </span>
              <div class="info-btn-wrap">
                <button type="button" @click="fileViewer(data)" class="ico_search" title="바로보기">바로보기</button>
                <button type="button" @click="fileDownload(data)" class="ico_down" title="다운로드">다운로드</button>
              </div>
            </div>
          </div>

        </li>
      </ul>
    </div>
    <div class="btn-layout center" v-if="isSearchData">
      <button type="button" class="info-more-btn" @click="searchStatReportList">더보기</button>
    </div>
  </div>
</template>

<script>
import * as api from '@/api/StatReport.js'
import * as file from '@/api/common/file.js'
import * as staticApi from '@/api/Statistics.js'
import * as noticeApi from '@/api/Notice.js'
import * as logApi from '@/api/Log'

export default {
	name: 'StatReportListItemName',
	components: {},

	data () {
		return {
      		statId: '',
			statReportCount: 6,
			statReportPageIndex: 0,
			statReportStartPage: 0,
			statReportEndPage: 0,
			selectCodeList: [],
			statReportDataList: [],
			paramModel: {
				sortGubun : 'date',
				classCode : '',
				statReportSearchText: ''
			},
			isSearchData: false
		}
	},

	props: {
		nameModel : {
			type: Object,
			deep: true
		}
	},
	watch: {
		nameModel: function () {
			this.searchModelInit();
		}
	},
	created(){
		this.$nextTick(() => {
			this.searchTextStatReportList();
		})
	},

	filters: {
		addComma: function (value) {
			return Number(value).toFixed(0)
        .replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, '$1,');
		}
	},
	methods: {

		searchModelInit() {
			this.paramModel.sortGubun = this.nameModel.sortGubun
			this.paramModel.classCode = this.nameModel.classCode			
			this.paramModel.statReportSearchText = this.nameModel.statReportSearchText
		},

    	searchTextStatReportList () {			
			this.statReportPageIndex = 0
			this.statReportStartPage = 0
			this.statReportEndPage = 0
			this.selectCodeList = []
			
			this.searchModelInit()
			
			this.$nextTick(()=>{
				this.searchStatReportList()
			})
		},

		// 통계보고서 데이터 조회
		async searchStatReportList () {
			// 통계보고서 페이징 인덱스 및 페이지 설정
			this.statReportPageIndex++;
			this.statReportStartPage = ((this.statReportPageIndex - 1) * this.statReportCount) + 1
			this.statReportEndPage = this.statReportPageIndex * this.statReportCount

			// 통계보고서 데이터 조회 파라미터 설정
			const paramData = {
				sortGb: this.paramModel.sortGubun,
				classCode: this.paramModel.classCode,
				searchText: this.paramModel.statReportSearchText,
				startPage: this.statReportStartPage,
				endPage: this.statReportEndPage
			}
			// 통계보고서 데이터 조회
			const statReportData = await api.searchStatReportList(paramData)

			if (this.statReportPageIndex === 1) {
				this.statReportDataList.splice(0, this.statReportDataList.length, ...statReportData.data);
			} else {
				this.statReportDataList.push(...statReportData.data);
			}

			// 통계보고서 데이터 개수가 게시물 조회 개수보다 작으면 더보기 버튼 숨김
			this.isSearchData = statReportData.data.length >= this.statReportCount;

			// 통계보고서 데이터가 존재하지 않을 경우 알림창 띄움
			if (statReportData.data.length === 0) {
				this.isSearchData = false;
				this.$nextTick(() => {
				alert('목록이 존재하지 않습니다.');
				});
			}
		},

		// 통계보고서 썸네일 이미지 파일 설정
		getImage (data) {
			if (data.attachFileList?.length) {
				const findData = data.attachFileList.filter(item => item.rptFileGb === '02')
				.map(item => {
					if (process.env.NODE_ENV === 'development')
						return item.directoryPath.replace('/mng/web/mcstmng/source/', 'https://stat.mcst.go.kr/mng/');
					else
						return item.directoryPath;
				}).at();

				return findData ? findData : require('@/assets/img/default_thumbnail.png');
			} else {
				return require('@/assets/img/default_thumbnail.png');
			}
		},

		errorImageHandler(event) {
		event.target.src = require('@/assets/img/default_thumbnail.png');
		},

		// 첨부파일 바로보기
		async fileViewer (data) {
			const frm = new FormData()

			let fileMgmNo = ''
			let rptFileGb = ''
			for (const fileData of data.attachFileList) {
				rptFileGb = fileData.rptFileGb.toLowerCase()
				if (rptFileGb === '01') {
					fileMgmNo = fileData.rptFileSeq
					break
				}
			}

			// 통계보고서 방문자수 업데이트
			await this.updateVistCount(data)

			frm.append('type', 'STATREPORT')
			frm.append('fileMgmNo', fileMgmNo)

			const statisticsData = await noticeApi.fileConvert(frm)

			const openUrl = statisticsData.data
			logApi.access(window.location.origin + openUrl);
			window.open(openUrl, '_blank')
		},

		// 파일 다운로드
		async fileDownload (data) {
			let fileMgmNo = ''
			let rptFileGb = ''
			for (const fileData of data.attachFileList) {
				rptFileGb = fileData.rptFileGb.toLowerCase()
				if (rptFileGb == '01') {
					fileMgmNo = fileData.rptFileSeq
					break
				}
			}

			const params = {
				type: 'STATREPORT',
				fileMgmNo: fileMgmNo
			}

			// 파일 다운로드 호출
			await file.download(params)

			// 파일 다운로드 로그
			const logParams = {
				downMenu: '통계보고서',
				downCntn: fileMgmNo
			}
			await staticApi.insertExcelDownLog(logParams)

			// 통계보고서 다운로드수 업데이트
			this.updateDownloadCount(data)
		},

		// 통계보고서 방문자수 업데이트
		async updateVistCount (data) {
			const frm = new FormData()
			frm.append('statRptId', data.statRptId)
			api.updateStatReportVistCount(frm)
			data.visitCnt = Number(data.visitCnt) + 1
		},

		// 통계보고서 다운로드수 업데이트
		async updateDownloadCount (data) {
			const frm = new FormData()
			frm.append('statRptId', data.statRptId)
			api.updateStatReportDownloadCount(frm)
		}
	}
}
</script>
